import React from 'react';
import PropTypes from 'prop-types';
import { translate } from '@utils/i18n';
import { exportCsvTimeEntriesPath, exportComputereasePayrollCsvTimeEntriesPath } from 'routes';
import ExportButton from './ExportButton';

const namespace = 'features.time_entries.index.mass_actions';

function MassActions({ state, onSelectAll, queryParams, hasComputereaseTimeEntryExport }) {
  const { totalCount, selectAll, selectedIds } = state;
  const selectedCount = selectAll ? totalCount : selectedIds.length;
  const hasSelection = selectedIds.length > 0 || selectAll;

  return (
    <div className="qmb-actions">
      {hasSelection && (
        <div className="actions__group--selection">
          <button type="button" className="actions__selection">
            <span className="actions__count">{selectedCount}</span>
          </button>
          {!selectAll && (
            <div className="actions__entire">
              <button type="button" tabIndex="0" className="qmb-control--sm" onClick={onSelectAll}>
                {translate('selected_global_counter', { namespace, count: totalCount })}
              </button>
            </div>
          )}
        </div>
      )}

      <div className="actions__group">
        <ExportButton
          queryParams={queryParams}
          selectedIds={selectedIds}
          selectAll={selectAll}
          exportPath={exportCsvTimeEntriesPath}
          translationKey="export_csv"
        />
        {hasComputereaseTimeEntryExport && (
          <ExportButton
            queryParams={queryParams}
            selectedIds={selectedIds}
            selectAll={selectAll}
            exportPath={exportComputereasePayrollCsvTimeEntriesPath}
            translationKey="export_payroll"
          />
        )}
      </div>
    </div>
  );
}

MassActions.propTypes = {
  state: PropTypes.shape({
    totalCount: PropTypes.number.isRequired,
    selectAll: PropTypes.bool.isRequired,
    selectedIds: PropTypes.arrayOf(PropTypes.number).isRequired
  }).isRequired,
  onSelectAll: PropTypes.func.isRequired,
  queryParams: PropTypes.object.isRequired,
  hasComputereaseTimeEntryExport: PropTypes.bool
};

MassActions.defaultProps = {
  hasComputereaseTimeEntryExport: false
};

export default MassActions;
